// Showcase Category Header Component
// Custom web component for displaying category headers

import type { ShowcaseCategory, TranslatedText } from "./showcase-config.ts";

class ShowcaseCategoryHeader extends HTMLElement {
  private config: ShowcaseCategory | null = null;

  connectedCallback() {
    this.render();
  }

  setConfig(config: ShowcaseCategory) {
    this.config = config;
    this.render();
  }

  private getCurrentLang(): string {
    if (typeof globalThis.getInitialLang === "function") {
      return globalThis.getInitialLang();
    }
    return "en";
  }

  private translate(text: TranslatedText): string {
    const lang = this.getCurrentLang();
    return text[lang as keyof TranslatedText] || text.en;
  }

  private render() {
    if (!this.config) return;

    this.innerHTML = `
      <div class="flex items-center gap-4 mb-8">
        <div class="flex-shrink-0">
          <div class="w-16 h-16 bg-gradient-to-br ${this.config.iconGradient} rounded-2xl flex items-center justify-center shadow-lg">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="${this.config.iconSvgPath}"></path>
            </svg>
          </div>
        </div>
        <div>
          <h2 class="text-3xl font-bold text-slate-900">
            <span data-en="${this.config.title.en}" data-lv="${this.config.title.lv}" data-it="${this.config.title.it}">
              ${this.translate(this.config.title)}
            </span>
          </h2>
          <p class="text-slate-600">
            <span data-en="${this.config.subtitle.en}" data-lv="${this.config.subtitle.lv}" data-it="${this.config.subtitle.it}">
              ${this.translate(this.config.subtitle)}
            </span>
          </p>
        </div>
      </div>
    `;
  }
}

customElements.define("showcase-category-header", ShowcaseCategoryHeader);

export { ShowcaseCategoryHeader };

